import AboutUs from "@/components/AboutUs";
import Szja from "@/components/Szja";
import Contact from "@/components/Contact";

export const routes = [
    {path: "/", component: AboutUs, name: "AboutUs"},
    {path: "/szja", component: Szja, name: "Szja"},
    {path: "/contact", component: Contact, name: "Contact"},
];
